import React from "react";
import styled from "styled-components";
import { DynamicButton, StyledText } from "../../../../components/common";
import DropDownWithOutline from "../../../../components/svgs/dropDownWithOutline";
import UploadIcon from "../../../../components/svgs/uploadIcon";

const StoryForm = ({
  onSubmit,
  title,
  story,
  category,
  coverImage,
  errors,
  submissionError,
  setTitle,
  setStory,
  setCategory,
  handleImageUpload,
  removeImage,
  actionType,
}) => {
  return (
    <Form>
      <div style={{ marginBottom: "32px" }}>
        <StyledText style={{ margin: "16px 0" }}>Title</StyledText>
        <Input
          type="text"
          placeholder="Add your voice to the conversation..."
          value={title}
          style={{ fontFamily: "MTNRegular" }}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        {errors.title && <ErrorMessage>{errors.title}</ErrorMessage>}
      </div>

      <div style={{ marginBottom: "32px" }}>
        <StyledText style={{ margin: "16px 0" }}>Main story</StyledText>
        <Textarea
          placeholder="Add your voice to the conversation..."
          value={story}
          style={{ fontFamily: "MTNRegular" }}
          onChange={(e) => setStory(e.target.value)}
          required
        />
        {errors.story && <ErrorMessage>{errors.story}</ErrorMessage>}
      </div>

      <div style={{ marginBottom: "32px", position: "relative" }}>
        <StyledText style={{ margin: "16px 0" }}>Category</StyledText>
        <Select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          style={{ fontFamily: "MTNRegular"}}
          required
        >
          <option value="">Select Category</option>
          <option value="Career">👔 Career</option>
          <option value="Culture">🔥 Culture</option>
          <option value="Education">📚 Education</option>
          <option value="Relationship">🩷 Relationship</option>
        </Select>
        <DropDownWrapper>
          <DropDownWithOutline />
        </DropDownWrapper>
        {errors.category && <ErrorMessage>{errors.category}</ErrorMessage>}
      </div>

      <div style={{ marginBottom: "32px", position: "relative" }}>
        <StyledText style={{ margin: "16px 0" }}>
          Upload Cover Picture
        </StyledText>
        {!coverImage && (
          <ImageUpload
            onClick={() => document.getElementById("coverImage").click()}
          >
            <UploadIcon />
            <label style={{ fontWeight: 700 }}>Add picture</label>
            <input
              type="file"
              id="coverImage"
              onChange={handleImageUpload}
              accept="image/*"
              style={{ display: "none" }}
            />
          </ImageUpload>
        )}
        {errors.coverImage && <ErrorMessage>{errors.coverImage}</ErrorMessage>}
      </div>

      {coverImage && (
        <ImagePreview>
          <img src={coverImage} alt="Cover Preview" />
          <RemoveButton onClick={removeImage}>Remove Picture</RemoveButton>
        </ImagePreview>
      )}

      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          background: "#fff",
          borderTop: "1px solid #ddd",
        }}
      >
        <div style={{ padding: "10px 30px", fontWeight: 700 }}>
          <DynamicButton
            onClick={onSubmit}
            label={actionType === "edit-story" ? "Update Story" : "Post story"}
            disabled={!title || !story || !category || !coverImage}
            color="#ffcc00"
            textColor="#333"
            fullWidth
          />
        </div>
      </div>
      {submissionError && <ErrorMessage>{submissionError}</ErrorMessage>}
    </Form>
  );
};

const Form = styled.form`
  width: 100%;
  max-width: 500px;
`;

const Input = styled.input`
  width: 93%;
  padding: 0 12px;
  margin: 0px 0;
  border: 1px solid #ddd;
  border-radius: 8px;
  min-height: 60px;
  outline: none;
`;

const Textarea = styled.textarea`
  width: 93%;
  padding: 12px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: vertical;
  min-height: 160px;
  outline: none;
`;

const Select = styled.select`
  width: 100%;
  padding: 12px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 8px;
  min-height: 60px;
  appearance: none;
  background: none;

  &:focus {
    outline: none;
    border-color: #ccc;
  }
`;

const ErrorMessage = styled.p`
  color: red;
  font-size: 12px;
  margin-top: 5px;
`;

const DropDownWrapper = styled.div`
  position: absolute;
  top: 67%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
`;

const ImageUpload = styled.div`
  margin: 10px 0;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  min-height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;

const ImagePreview = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: center;
  position: relative;

  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    border: 1px solid #ddd;
  }
`;

const RemoveButton = styled.button`
  position: absolute;
  width: 189px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.7);
  color: #333;
  border: none;
  border-radius: 50px;
  height: 30px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.9);
    color: #333;
  }
`;

export default StoryForm;
